import "@arco-design/web-react/es/Dropdown/style";
import _Dropdown from "@arco-design/web-react/es/Dropdown";
import "@arco-design/web-react/es/Avatar/style";
import _Avatar from "@arco-design/web-react/es/Avatar";
import _IconPoweroff from "@arco-design/web-react/icon/react-icon/IconPoweroff";
import "@arco-design/web-react/es/Divider/style";
import _Divider from "@arco-design/web-react/es/Divider";
import "@arco-design/web-react/es/Menu/style";
import _Menu from "@arco-design/web-react/es/Menu";
import _IconSettings from "@arco-design/web-react/icon/react-icon/IconSettings";
import { useAuth } from '@/providers/AuthProvider';
import React from 'react';
import { useNavigate } from 'react-router-dom';
export function UserDropdown() {
  const navigate = useNavigate();
  const {
    logout
  } = useAuth();
  const droplist = /*#__PURE__*/React.createElement(_Menu, {
    onClickMenuItem: key => {
      if (key === 'logout') {
        logout();
      } else if (key === 'setting') {
        navigate('/account/setting');
      } else {// Message.info(`You clicked ${key}`);
      }
    }
  }, /*#__PURE__*/React.createElement(_Menu.Item, {
    key: "setting"
  }, /*#__PURE__*/React.createElement(_IconSettings, null), "\u7528\u6237\u8BBE\u7F6E"), /*#__PURE__*/React.createElement(_Divider, {
    style: {
      margin: '4px 0'
    }
  }), /*#__PURE__*/React.createElement(_Menu.Item, {
    key: "logout"
  }, /*#__PURE__*/React.createElement(_IconPoweroff, null), "\u9000\u51FA"));
  return /*#__PURE__*/React.createElement(_Dropdown, {
    droplist: droplist,
    position: "br"
  }, /*#__PURE__*/React.createElement(_Avatar, {
    size: 32,
    style: {
      cursor: 'pointer'
    }
  }, /*#__PURE__*/React.createElement("img", {
    alt: "avatar",
    src: 'https://images.unsplash.com/photo-1567945716310-4745a6b7844b?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1500&q=60'
  })));
}